import { Button } from 'reactstrap';

interface CalendarViewControlsProps {
  onChangeView: (view: string) => void;
}

const CalendarViewControls = ({ onChangeView }: CalendarViewControlsProps) => (
  <>
    <Button
      className="btn-neutral"
      color="default"
      onClick={() => onChangeView('dayGridMonth')}
      size="sm"
    >
      Vista de mes
    </Button>
    <Button
      className="btn-neutral"
      color="default"
      onClick={() => onChangeView('dayGridWeek')}
      size="sm"
    >
      Vista 3 días
    </Button>
    <Button
      className="btn-neutral"
      color="default"
      onClick={() => onChangeView('dayGridDay')}
      size="sm"
    >
      Vista día
    </Button>
  </>
);

export default CalendarViewControls;
